import React from "react";
import { Link } from "react-router-dom";
import MainBanner from "../../components/MainComponents/MainBanner";
import Footer from "../../components/MainComponents/Footer";
import { bannerServiceImage, mainTitle, patientBanner } from "../../config";
import PatientFormList from "../../components/PatientComponents/PatientFormList";
import AppointmentSection from "../../components/ServiceComponents/AppointmentSection";
import FAQSection from "../../components/PatientComponents/FAQ";
import { routeNames } from "../../routes/routeNames";

const PatientForms = () => {
  const forms = [
    {
      id: 1,
      title: "New Patient Forms",
      icon: "📝",
      link: routeNames.newpatientform,
    },
    {
      id: 2,
      title: "Patient Intake Form",
      icon: "📄",
      link: "/patient-intake-form",
    },
    { id: 3, title: "Consent Form", icon: "✔️", link: "/consent-form" },
    {
      id: 4,
      title: "Benefit Assignment Consent Form",
      icon: "📑",
      link: "/benefit-assignment-form",
    },
  ];

  return (
    <div>
      {/* Main Banner */}
      <MainBanner
        
        bannerTitle={mainTitle}
        banenrHeadline={"Patient Forms"}
        showButton={false}
        bannerDescription={
          "Complete all necessary forms before your appointment to ensure a smooth and efficient experience."
        }
      />

    <PatientFormList forms={forms}/>
    <AppointmentSection/>

    <FAQSection/>

    

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default PatientForms;
